import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "./services/auth.service";

export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    if (authService.isLoggedIn()) {
       if(!authService.isProfilCompleted()) {
           router.navigate(['/signup']);
           return false;
       }

       return true;
    }

    return router.navigate(["/login"]);
};
